/**
 * Convert an absolute route path to one relative to a parent splat route.
 * Descendant <Routes> under React Router v6+ match against the remaining
 * pathname after the parent, so absolute constants like `/panel/officials/list`
 * must become `/list` when nested under `/panel/officials/*`.
 */
export function relativePath(absolutePath: string, parentPath: string): string {
  const parent = parentPath.replace(/\/\*$/, '').replace(/\/$/, '');
  const hasSplat = absolutePath.endsWith('/*');
  const path = hasSplat ? absolutePath.slice(0, -2) : absolutePath;

  if (!parent || path === parent) {
    return hasSplat ? '/*' : '/';
  }

  if (path.startsWith(`${parent}/`)) {
    const relative = path.slice(parent.length);
    return hasSplat ? `${relative}/*` : relative;
  }

  return absolutePath;
}
